import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Scroll-Verhalten bei jedem Seitenwechsel (global in App.js):
 * - Zurück/Vor (POP): gemerkte Position wiederherstellen (wartet, bis der Inhalt geladen ist).
 * - Mit Hash: weich zum Anker scrollen.
 * - Sonst: nach oben.
 */
const HEADER_OFFSET = 130;
const SPEICHER = 'scroll-positionen';
const positionen = (() => { try { return JSON.parse(sessionStorage.getItem(SPEICHER) || '{}'); } catch { return {}; } })();

const ScrollToTop = () => {
  const { pathname, hash, key } = useLocation();
  const art = useNavigationType();
  const vorher = useRef(null);

  useEffect(() => {
    let raf = 0;
    const f = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { positionen[key] = window.scrollY; try { sessionStorage.setItem(SPEICHER, JSON.stringify(positionen)); } catch { /* voll */ } }); };
    window.addEventListener('scroll', f, { passive: true });
    return () => { window.removeEventListener('scroll', f); cancelAnimationFrame(raf); };
  }, [key]);

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;
    const gleich = vorher.current === pathname + hash;
    vorher.current = pathname + hash;
    if (art !== 'POP' && gleich) return undefined;
    if (art === 'POP' && positionen[key] > 0) {
      const ziel = positionen[key];
      const wiederherstellen = () => {
        if (cancelled) return;
        if (document.documentElement.scrollHeight - window.innerHeight >= ziel - 5 || attempts >= 40) { window.scrollTo({ top: ziel, behavior: 'instant' }); return; }
        attempts += 1;
        setTimeout(wiederherstellen, 75);
      };
      wiederherstellen();
      return () => { cancelled = true; };
    }
    if (hash && !hash.includes('session_id=')) {
      const id = hash.replace('#', '');
      const tryScroll = () => {
        if (cancelled) return;
        const el = document.getElementById(id);
        if (el) {
          const y = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
          window.scrollTo({ top: y, behavior: 'smooth' });
        } else if (attempts < 30) {
          attempts += 1;
          setTimeout(tryScroll, 100);
        }
      };
      tryScroll();
      return () => { cancelled = true; };
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    return undefined;
  }, [pathname, hash, key, art]);

  return null;
};

export default ScrollToTop;
